import React from 'react';

interface PageHeaderProps {
  title: string;
  description: string;
}

export const PageHeader: React.FC<PageHeaderProps> = React.memo(({ title, description }) => {
  return (
    <section className="bg-primary text-primary-foreground py-8">
      <div className="node-container text-center">
        <h1 className="text-4xl font-bold mb-4">{title}</h1>
        <p className="text-lg opacity-90 max-w-2xl mx-auto">
          {description}
        </p>
      </div>
    </section>
  );
});

PageHeader.displayName = 'PageHeader';